module.exports = __webpack_public_path__ + "gfx/safecall-logo.png";